import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import CardSlider from "../components/Slider/CardSlider";
import FlipCardSlider from "../components/Slider/FlipCardSlider";
import CardSlider2 from "../components/Slider/CardSlider2";
import Accordion from "../components/Accordion/Accordion";
import RoiCTA from "../components/CTA/RoiCTA";
import FeaturedContent from "../components/Featured/FeaturedContent";
import CardContainer from "../components/Card/CardContainer";
import Card from "../components/Card/Card";
import { useModal } from "../context/ModalContext";
import FAQs from "../components/FAQ/FAQs";
import Testimonials from "../components/Testimonials/Testimonials";
import Page from "../layout/Page";

const faqData = [
  {
    question: "How does FleetSense reduce my fuel costs?",
    answer:
      "Through Real-Time GPS tracking FleetSense inprove navigation and routing through Data-Driven decisions.",
  },
  {
    question:
      "How can FleetSense help me improve my transportation efficiency?",
    answer:
      "By leveraging real-time data for route optimisation, driver behaviour monitoring, and predictive maintenance.",
  },
  {
    question: "How can I reduce my carbon footprint?",
    answer:
      "By using real-time data for route optimisation, driver behaviour monitoring, and predictive maintenance.",
  },
  {
    question: "What is the benefits of FleetSense for my business?",
    answer:
      "FleetSense offers a comprehensive solution for businesses looking to improve their transportation efficiency, reduce fuel costs, and drive unparalleled customer satisfaction.",
  },
];

const fleetsensefeatures = [
  {
    id: 1,
    category: "Fleet Management",
    title: "Enhanced 360-degree insights with GPS Tracking",
    description:
      "Harnessing cloud-based technology, machine learning, and artificial intelligence, our solutions provide a 360-degree view of fleet operations. Our flagship, state-of-the-art Driver State Monitoring System elevates delivery efficiency to new heights.",
    image: "/images/features/13.png",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 2,
    category: "Fuel Management",
    title: "Cut Costs, Boost Productivity, and Maximise Fuel Efficiency Daily",
    description:
      "Optimise fuel usage, enhance productivity, stay proactive with vehicle maintenance, and drive unparalleled efficiency every day.",
    image: "/images/features/14.png",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 3,
    category: "Control Room",
    title: "24/7 Fleet Protection with Our Expert Life Savers",
    description:
      "Let our experts safeguard your fleet operations around the clock. We monitor your dashboard for alerts, coordinate directly with drivers in real time, and keep you informed every step of the way—ensuring you're always in control and close to the action.",
    image: "/images/features/15.png",
    // link: "#",
    // linkText: "Read more",
  },
];

const FleetSense = () => {
  const { openModal } = useModal();
  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <Page
      title="FleetSense | GPS Fleet Tracking Software for Efficient Fleet Management"
      description="FleetSense is the ultimate fleet management solution for businesses seeking to optimize fuel costs, enhance fleet safety, and drive productivity with real-time GPS tracking and telematics."
      keywords="FleetSense, fleet tracking, fleet management software, GPS tracking, telematics, reduce fuel costs, fleet safety, logistics optimization"
      structuredData={{
        "@context": "https://schema.org",
        "@type": "Product",
        name: "FleetSense",
        image: "/images/hero/fleet-sense-3.webp",
        description:
          "FleetSense is a comprehensive fleet management solution that uses GPS tracking and telematics to reduce fuel costs, improve fleet safety, and optimize operational efficiency.",
        brand: {
          "@type": "Brand",
          name: "Shoora",
        },
        offers: {
          "@type": "Offer",
          url: "#pricing",
          priceCurrency: "USD",
          price: "Available upon request",
          priceValidUntil: "2025-12-31",
          availability: "https://schema.org/InStock",
          eligibleRegion: {
            "@type": "Place",
            name: "Global",
          },
        },
      }}
    >
      <div className="about-hero hero-2 w-100">
        <img
          src="/images/hero/fleet-sense-3.webp"
          alt="Shoora Fleet Sense Hero"
          className="w-100"
          style={{ objectFit: "cover" }}
        />
        <div
          className="row position-absolute p-5 w-100"
          style={{ top: "80px" }}
        >
          <div className="col col-12 col-lg-6 pe-lg-5">
            <p
              className="fs-6 text-white mt-4"
              style={{ lineHeight: 0.5, marginBottom: "0px !important" }}
            >
              {/* Enhanced safety and safeguard your fleet */}
            </p>
            <h1
              className="text-accent fw-bold mt-5 mb-4 display-3"
              style={{ lineHeight: 0.9, marginBottom: "0px !important" }}
            >
              Fleet
              <i className="fw-light text-light">Sense</i> <br />
            </h1>
            <p className="fs-5  text-accent">
              Advanced GPS Fleet Tracking Software
            </p>
            <p className="fs-6 text-light mb-5 pe-5">
              Fleet Sense is the ultimate fleet management solution, empowering
              fleet owners to boost productivity, enhance efficiency, and unlock
              significant cost savings.
            </p>
            <div className="d-flex pb-5">
              <button className="btn btn-light rounded-5" onClick={openModal}>
                See Plans & Pricing
              </button>
              <a
                className="ms-3 btn btn-link text-light fw-bold text-decoration-none"
                onClick={openModal}
                href="#cta"
              >
                Get a Demo
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Navigation Bar */}
      <div className="container-fluid bg-black sticky-top d-none d-lg-block">
        <div className="container nav-links">
          <ul className="navigation-group">
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("overview")}
                className="navigation-item-link btn btn-link text-white"
              >
                Overview
              </button>
            </li>

            <li className="navigation-item">
              <button
                onClick={() => handleScroll("features")}
                className="navigation-item-link btn btn-link text-white"
              >
                Features
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("benefits")}
                className="navigation-item-link btn btn-link text-white"
              >
                Benefits
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("testimonials")}
                className="navigation-item-link btn btn-link text-white"
              >
                Testimonials
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("faqs")}
                className="navigation-item-link btn btn-link text-white"
              >
                FAQs
              </button>
            </li>
          </ul>
        </div>
      </div>
      {/* <FeaturedContent /> */}

      <section id="overview" className="container">
        <div className="row align-items-center">
          <div className="col col-12 col-lg-7 ps-lg-5">
            <h6 className="fs-bold text-accent">Why FleetSense</h6>
            <h1 className="mb-4">
              Transforming Logistics with Fleet Intelligence and Telematics
            </h1>
            <p className="mb-5">
              Rising fuel prices, fuel theft, cargo safety concerns, frequent
              accidents, and the need for optimised navigation routes have
              driven large logistics transporters to seek enhanced connectivity
              and intelligence in their vehicles. Leveraging telematics data
              across an entire fleet can significantly reduce operational costs
              and boost business efficiency.
            </p>
          </div>
          <div className="col">
            <img
              src="/images/products/fleetsense1.png"
              alt=""
              className="w-100 pt-5 p-lg-0 pe-0"
            />
          </div>
        </div>
      </section>

      <div className="container">
        <div className="row align-items-center">
          <div className="col col-12 col-lg-5 ps-lg-5">
            {/* <h1 className='mb-4'>Fleet dash cams have a live view of the road</h1> */}

            <p className="mb-5">
              <p>
                Our solution, FleetSense, a Fleet Safety Solution is designed to
                detect risks and protect fleets, ultimately reducing the cost of
                ownership and improving return on investment (ROI). By
                implementing smart cabins, fleets can improve workplace safety
                and decrease driver-related costs. Mobility management companies
                and fleet operators will provide a spectrum of passenger
                experiences to cater to diverse needs and offer options at
                various price points. Vehicle telematics improve driver work
                habits and reduce claim costs, enabling larger carriers to lower
                their operating expenses compared to smaller carriers.
              </p>
            </p>
            <button className="btn btn-outline-dark btn-lg rounded-5">
              See Plan & Pricing
            </button>
          </div>
          <div className="col">
            <img
              src="https://assets.verizonconnect.com/cdn-cgi/image/width=1294,height=830,format=auto/solutions/fleet-dash-cam/us-coaching-insights.png"
              alt=""
              className="w-100 pt-5 p-lg-5 pe-0"
            />
          </div>
        </div>
      </div>
      <section id="features" className="my-5">
        <CardSlider2 data={fleetsensefeatures} />
      </section>

      <section id="benefits">
        <CardContainer
          heading="Benefits"
          desc="Discover how this solution drives business success while making roads safer."
        >
          <Card
            // category="Safety"
            bgColor="#f4f4f4"
            type="primary"
            headingColor="#0d004a"
            heading="Real-time Visibility & Alerts"
            desc="Stay connected to your fleet with live vehicle tracking, diagnostics, and sensor data. Receive instant in-app alerts for critical events, ensuring seamless fleet operations anytime, anywhere."
            imgsrc="/images/benefits/7.png"
            // linkText="See Plans & Pricing"
          />
          <Card
            // category="Visibility"
            bgColor="#eaca13"
            type="vibrant"
            heading="Cost Optimization with Telematics"
            desc="Reduce operational expenses by optimizing fuel consumption, improving navigation, and leveraging data-driven insights. FleetSense helps fleet owners mitigate risks, enhance safety, and achieve higher returns on investment."
            imgsrc="/images/benefits/10.png"
          />
          <Card
            // category="Coaching insights"
            type="primary"
            heading="24/7 Fleet Protection"
            desc="Our expert monitoring team safeguards your fleet around the clock, coordinating directly with drivers, addressing alerts in real time, and keeping you informed to ensure maximum safety and control."
            imgsrc="/images/benefits/11.png"
            // linkText="See Plans & Pricing"
          />
        </CardContainer>
      </section>

      <section id="testimonials" className="testimonials-section section">
        <div className="container">
          <Testimonials />
        </div>
      </section>

      <section id="faqs">
        <FAQs
          data={faqData}
          title="Your questions about FleetSense™, answered."
        />
      </section>
    </Page>
  );
};

export default FleetSense;
